"use client"
import { useIsScrolled } from "@/app/hooks/useIsScrolled"
import { Box, Fade } from "@mui/material"
import Link from "next/link"

export const FeaturedOnPH = () => {
    const isScrolled = useIsScrolled()

    return (
        <Fade in={!isScrolled} timeout={500}>
            <Box
                sx={{
                    zIndex: 100,
                    position: "fixed",
                    bottom: "10px",
                    left: "10px",
                    right: "auto",
                    display: { xs: "none", md: "block" },
                }}
            >
                <Link
                    href="https://www.producthunt.com/posts/active-recall?embed=true&utm_source=badge-top-post-badge&utm_medium=badge&utm_souce=badge-active&#0045;recall"
                    target="_blank"
                >
                    <Box
                        component="img"
                        src="/svgs/product_hunt_product_of_the_month.svg"
                        alt="Recall Browser Extension on Product Hunt"
                        width={250}
                        height={54}
                    />
                </Link>
            </Box>
        </Fade>
    )
}
